import { store$, store } from '@redux/store';
import { map, distinctUntilChanged } from 'rxjs';
import { selectArticlesQueryStringParameters } from 'features/articleSearchResultsFacets';
import { routingStateActions } from 'features/routing';

const dispatchNewQueryString = function(queryString){
    store.dispatch(routingStateActions.updateQueryString(queryString));
}

// observer to map search command but only emmit if the fetching flag is true
const onQueryStringChange$ = store$.pipe(
    map(selectArticlesQueryStringParameters),
    distinctUntilChanged()
);
    
onQueryStringChange$.subscribe(dispatchNewQueryString);